module.exports = __webpack_public_path__ + "static/img/teBuContent6.4427aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teBuContent6.png
// module id = K1VO
// module chunks = 2